import { useState, useContext, useEffect } from "react";
import { PatrimonioContext } from "../../../contexts/patrimonioProvider";
import { UserContext } from "../../../contexts/userProvider";
import BaseInput from "../../General/FormsComp/Input/BaseInput";
import BaseButton from "../../General/FormsComp/Button/BaseButton";

const Cadastro = (props) => {
    const { criarGrupo, editarGrupo } = useContext(PatrimonioContext);
    const { setAlert } = useContext(UserContext);
    const [novoGrupo, setNovoGrupo] = useState({
        nome: "",
    });

    // Carrega dados do grupo para edição
    useEffect(() => {
        if (props.isEdit && props.grupo) {
            setNovoGrupo({
                nome: props.grupo.nome || "",
                id: props.grupo.id
            });
        }
    }, [props.isEdit, props.grupo]);

    const handleInput = (e) => {
        const { value, name } = e.target;
        setNovoGrupo({ ...novoGrupo, [name]: value });
    };

    const handleCreateGrupo = async () => {
        // Validação
        if (!novoGrupo.nome.trim()) {
            setAlert({
                type: 'warning',
                placeholder: 'O nome do grupo é obrigatório!',
                visible: true,
                confirm: false,
                title: 'Atenção!'
            });
            return;
        }

        try {
            let success;
            
            if (props.isEdit) {
                // Editando grupo existente
                let updatedG = { ...novoGrupo };
                updatedG.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
                success = await editarGrupo(updatedG);
                
                if (success) {
                    setAlert({
                        type: 'success',
                        placeholder: 'Grupo atualizado com sucesso!',
                        visible: true,
                        confirm: false,
                        title: 'Sucesso'
                    });
                }
            } else {
                // Criando novo grupo
                let newG = { ...novoGrupo };
                newG.created_at = newG.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
                success = await criarGrupo(newG);
                
                if (success) {
                    setAlert({
                        type: 'success',
                        placeholder: 'Grupo criado com sucesso!',
                        visible: true,
                        confirm: false,
                        title: 'Sucesso'
                    });
                }
            }

            if (success) {
                props.setCadastroModal(false);
            }
        } catch (error) {
            console.error('Erro ao salvar grupo:', error);
            setAlert({
                type: 'negative',
                placeholder: `Erro ao ${props.isEdit ? 'atualizar' : 'criar'} grupo. Tente novamente.`,
                visible: true,
                confirm: false,
                title: 'Erro'
            });
        }
    }

    return (
        <div className="p-6">
            <div className="space-y-6">
                <BaseInput
                    label="Nome do Grupo"
                    name="nome"
                    value={novoGrupo.nome}
                    onChange={handleInput}
                    type="text"
                    required
                    placeholder="Digite o nome do grupo"
                />
            </div>
            
            <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
                <BaseButton
                    variant="ghost"
                    onClick={(e) => props.setCadastroModal(false)}
                >
                    Cancelar
                </BaseButton>
                <BaseButton
                    variant="primary"
                    onClick={handleCreateGrupo}
                >
                    {props.isEdit ? 'Atualizar' : 'Criar Grupo'}
                </BaseButton>
            </div>
        </div>
    );
};

export default Cadastro;
